import { render } from "./heatingGhController.vue?vue&type=template&id=0a95e676&scoped=true"
import script from "./heatingGhController.vue?vue&type=script&lang=js"
export * from "./heatingGhController.vue?vue&type=script&lang=js"

import "./heatingGhController.vue?vue&type=style&index=0&id=0a95e676&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a95e676"]])

export default __exports__